import styled, { css, Keyframes } from "styled-components";

export interface IconButtonProps {
  bgColor?: string;
  hoverColor?: string;
  color?: string;

  position?: string;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  margin?: string;
  padding?: string;
  borderRadius?: string;
  transition?: string;
  transform?: string;
  animation?: { keyframes?: Keyframes; style?: string };
}
export const IconButton = styled.button.attrs(p => ({
  type: p.type || "button",
}))<IconButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  border-radius: ${p => p.borderRadius || "50%"};
  color: ${p => p.color || p.theme.colors.text.primary};
  background-color: ${p => p.bgColor || "transparent"};
  padding: ${p => p.padding || "0.15rem"};
  margin: ${p => p.margin || "0 0.2rem"};
  transition: transform 0.1s ease-in-out;
  ${p => p.position && `position: ${p.position}`};
  ${p => p.top && `top: ${p.top}`};
  ${p => p.right && `right: ${p.right}`};
  ${p => p.bottom && `bottom: ${p.bottom}`};
  ${p => p.left && `left: ${p.left}`};
  ${p => p.transition && `transition: ${p.transition}`};
  ${p => p.transform && `transform: ${p.transform}`};

  &:hover {
    ${p => p.hoverColor && `color: ${p.hoverColor}`};
    transform: scale(1.05);
  }
  &:active {
    transform: scale(0.95);
  }
  &:disabled {
    opacity: ${p => p.theme.colors.action.disabledOpacity};
    color: ${p => p.theme.colors.action.disabled};
    cursor: default;
    &:active,
    &:hover {
      transform: scale(1);
    }
  }
  ${p =>
    p.animation &&
    css`
      animation: ${p.animation.keyframes} ${p.animation.style};
    `}
`;
